import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles(() => createStyles({
  developerHover: {
    position: 'relative',
    transition: 'all 0.5s',
    cursor: 'pointer',
    '&:hover': {
      boxShadow: '1px 0px 5px -1px black',
    },
  },
  complexStatus: {
    position: 'absolute',
    left: 0,
  },
  modalWindow: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    outline: '0',
  },
  btn: {
    padding: '15px 30px',
    fontSize: '18px',
  },
  closeBtn: {
    cursor: 'pointer',
    opacity: '0.5',
    '&:hover': {
      opacity: '1',
    },
  },
}));
